export class Coupon {
    couponcode: string;
    description: string;
}
